import React from 'react';
import { StatusBar } from '../components/StatusBar';
import { HeroSection } from '../components/HeroSection';
import { StorySection } from '../components/StorySection';
import { SolutionSection } from '../components/SolutionSection';
import { ProductSection } from '../components/ProductSection';
import { ValueStack } from '../components/ValueStack';
import { FAQSection } from '../components/FAQSection';
import { CTASection } from '../components/CTASection';
export function LandingPage() {
  return <div className="min-h-screen bg-cream font-body text-charcoal-700" data-id="element-138">
      <StatusBar data-id="element-139" />
      <main data-id="element-140">
        <HeroSection data-id="element-141" />
        <StorySection data-id="element-142" />
        <SolutionSection data-id="element-143" />
        <ProductSection data-id="element-144" />
        <ValueStack data-id="element-145" />
        <FAQSection data-id="element-146" />
        <CTASection data-id="element-147" />
      </main>
      <footer className="bg-charcoal-800 text-cream/60 py-8 text-center text-sm" data-id="element-148">
        <div className="max-w-7xl mx-auto px-4" data-id="element-149">
          <p data-id="element-150">
            © {new Date().getFullYear()} The Cortisol Code. All rights
            reserved.
          </p>
          
        </div>
      </footer>
    </div>;
}